import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SasSpinnerService } from '@services';

@Component({
    selector: 'sas-spinner',
    standalone: true,
    imports: [TranslateModule],
    template: `
        @if (isLoading() || isCustomLoading) {
        <div class="sas-spinner" [class.custom-loading]="isCustomLoading">
            <div class="loading">
                <span class="loader"></span>
                <p class="loader-legend" role="status" aria-live="polite" translate="LOADING"></p>
            </div>
        </div>
        }
    `,
    styleUrl: './sas-spinner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SasSpinnerComponent {
    @Input() isCustomLoading: boolean = false;

    spinnerService = inject(SasSpinnerService);

    isLoading = this.spinnerService.isLoading;
}
